/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nda_Signed_SuccessInputs */



/**
* | output |
* | --- |
* | "Agreement signed — the sealed PDF is on record." |
*
* @param {Nda_Signed_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const nda_signed_success = /** @type {((inputs?: Nda_Signed_SuccessInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nda_Signed_SuccessInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accord signé — le PDF scellé est enregistré.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Acuerdo firmado — el PDF sellado queda registrado.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Acordo assinado — o PDF selado está registrado.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Accordo firmato — il PDF sigillato è registrato.")
	return /** @type {LocalizedString} */ ("Agreement signed — the sealed PDF is on record.")
});